function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { phoneMask } from '@l/input-mask';
export function partsToStr() {
  var tpl = '';
  var count = 0;
  window.gParts.forEach(function (item) {
    tpl = tpl + "<b class=\"basket__parts__item\" data-id=\"".concat(count, "\" data-price=\"").concat(item.price, "\">").concat(item.info, " \u043D\u0430 ").concat(item.name, ": \u043E\u0442 ").concat(item.price, "\u20BD <img class=\"basket__parts__btm__del\" src=\"img/icons/trash-red.svg\" title=\"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0443\u0441\u043B\u0443\u0433\u0443\" alt=\"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0443\u0441\u043B\u0443\u0433\u0443\"><b></b></b>");
    count++;
  });
  return tpl;
}
export function refreshBasket() {
  if (window.gCount > 0) {
    // $('.basket__clear').classList.remove('hidden')
    $('.basket').classList.add('active');
    $('.basket__notify').classList.add('active');
  } else {
    $('.basket').classList.remove('active');
    $('.basket__notify').classList.remove('active');
    // $('.basket__clear').classList.add('hidden')
  }
  localStorage.setItem('count', window.gCount);
  localStorage.setItem('parts', JSON.stringify(window.gParts));
  localStorage.setItem('price', window.gPrice);
  $('.basket__notify').textContent = window.gCount;
  $('.basket__count').textContent = window.gCount;
  $('.basket__summa').textContent = "".concat(window.gPrice);
}
export function clearBasket() {
  window.window.gCount = 0;
  window.window.gPrice = 0;
  window.window.gParts = [];
  $('.basket__summa').textContent = "0";
  $('.basket__count').textContent = 0;
  $('.basket__notify').classList.remove('active');
  $('.basket__notify').textContent = 0;
  // $('.basket__desc').textContent = ``

  $$('.part__item').forEach(function (el) {
    el.classList.remove('active');
  });
  $('.basket ').classList.remove('active');

  // $('.basket__clear').classList.add('hidden')

  localStorage.setItem('count', 0);
  localStorage.setItem('parts', JSON.stringify([]));
  localStorage.setItem('price', 0);
}
export function basket() {
  $$('.part__item').forEach(function (elem) {
    sound_click(elem);
  });
  if (!localStorage.getItem('count')) {
    window.window.gCount = 0;
    window.window.gPrice = 0;
    window.window.gParts = [];
  } else {
    window.window.gCount = +localStorage.getItem('count');
    window.window.gPrice = +localStorage.getItem('price');
    window.window.gParts = JSON.parse(localStorage.getItem('parts'));
    $('.basket__notify').textContent = window.gCount;
    $('.basket__count').textContent = window.gCount;
    $('.basket__summa').textContent = "".concat(window.gPrice);
    // $('.basket__desc').innerHTML = partsToStr()
  }
  if (!$('.basket')) return;
  if (window.gCount > 0) {
    $('.basket__notify').classList.add('active');
    // $('.basket__clear').classList.remove('hidden')  
  } else {
    $('.basket__notify').classList.remove('active');
    // $('.basket__clear').classList.add('hidden')
  }
  $('.basket__close').onclick = function (e) {
    return $('.basket').classList.remove('active');
  };
  $('.basket__open').onclick = function (e) {
    if (gCount < 1) cPush.show({
      title: "Корзина пустая"
    });else $('.basket').classList.add('active');
  };
  $('.basket__clear').onclick = function () {
    cPush.show({
      text: "Корзина очищена"
    });
    clearBasket();
  };
  $$('.part__item').forEach(function (elem) {
    elem.addEventListener('click', function (e) {
      if (typeof ym === 'function') ym(49104928, 'reachGoal', 'model__price');
      var price = +elem.getAttribute('data-price');
      var part = {
        name: elem.getAttribute('data-name'),
        info: elem.getAttribute('data-info'),
        img: elem.getAttribute('data-img'),
        video: elem.getAttribute('data-video'),
        price: price
      };
      elem.classList.toggle('active');
      if (elem.classList.contains('active')) {
        window.gPrice = +window.gPrice + price;
        window.gCount = window.gCount + 1;
        window.gParts.push(part);
        window.gParts = _toConsumableArray(new Set(window.gParts));
      } else {
        window.gPrice = +window.gPrice - price;
        window.gCount = window.gCount - 1;
        for (var i = 0; i < window.gParts.length; i++) if (window.gParts[i].info === elem.getAttribute('data-info') && window.gParts[i].name === elem.getAttribute('data-name') && +window.gParts[i].price === +elem.getAttribute('data-price')) {
          window.gParts.splice(i, 1);
          break;
        }
        if ($('.basket__notify').textContent == 0) $('.basket__notify').classList.remove('active');
        if (window.gPrice == 0) $('.basket').classList.remove('active');
      }
      refreshBasket();
    });
  });
  $$('.part__item').forEach(function (elem) {
    var name = elem.getAttribute('data-name');
    var info = elem.getAttribute('data-info');
    window.gParts.forEach(function (item) {
      if (item.name == name && item.info == info) elem.classList.add('active');
    });
  });
  var basketDeleteItem = function basketDeleteItem() {
    sound_hover($('.malert__zayavka__open'));
    [].forEach.call($$(".basket__parts__btm__del"), function (el) {
      sound_hover(el);
      el.addEventListener("click", function (e) {
        soundPush('/sound/ps5/ps5-scroll.mp3');
        var id = +el.parentElement.getAttribute('data-id');
        window.gParts = window.gParts.filter(function (item, index) {
          return index !== id;
        });
        var price = +el.parentElement.getAttribute('data-price');
        window.gCount = +window.gCount - 1;
        window.gPrice = +window.gPrice - price;
        el.parentElement.remove();
        $$('.part__item').forEach(function (elem) {
          var name = elem.getAttribute('data-name');
          var info = elem.getAttribute('data-info');
          if (el.parentElement.textContent.includes(name) && el.parentElement.textContent.includes(info)) elem.classList.remove('active');
        });
        refreshBasket();
        if ($('.refresh__summa')) $('.refresh__summa').textContent = window.gPrice;
        if (window.gCount == 0 || window.gCount < 0) {
          clearBasket();
          malert.hide();
        }
      });
    });
  };
  $('.basket__details').onclick = function () {
    malert.show({
      title: "\u0421\u043F\u0438\u0441\u043E\u043A \u0443\u0441\u043B\u0443\u0433 \u043D\u0430 \u0441\u0443\u043C\u043C\u0443: <b class=\"refresh__summa\">".concat(window.gPrice, "</b>\u20BD"),
      text: partsToStr(),
      zayavkaBtm: true
    }).then(function () {
      return basketDeleteItem();
    });
  };
  $('.basket__send').onclick = function () {
    malert.show({
      title: "\u041E\u0442\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u0437\u0430\u044F\u0432\u043A\u0443",
      text: "\u041F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u043C \u0412\u0430\u043C \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 5 \u043C\u0438\u043D\u0443\u0442",
      zayavka: true
      // whatsapp:true,
      // whatsappText:`Здраствуйте необходимо починить ${tpl}. Могу ли оформить заказ?`,
      // img: `img/icons/send.svg`,
    }).then(function () {
      if (!isMobile()) $(".malert__form input").focus();
      phoneMask();
    });
  };
}